import styled from '@emotion/styled';
import { Button } from '@material-ui/core';
import MoreHoriz from '@material-ui/icons/MoreHoriz';
import { createElement, FC, useMemo } from 'react';
import { FormattedMessage } from 'react-intl';

interface Props {
  onSubmit: () => void;
  disabled: boolean;
  className?: string;
  isProcessing: boolean;
}

const SubmitButton: FC<Props> = ({ onSubmit, disabled, className, isProcessing }) => {
  const submitButton = useMemo(() => {
    if (isProcessing) {
      return (
        <Root variant="contained" disabled className={className}>
          <MoreHoriz />
        </Root>
      );
    } else {
      return (
        <Root variant="contained" onClick={() => onSubmit()} className={className} disabled={disabled}>
          <FormattedMessage id="show_creation_page.submit_creative" />
        </Root>
      );
    }
  }, [className, disabled, onSubmit, isProcessing]);

  return submitButton;
};

const Root = styled(Button)();
Root.defaultProps = { color: 'primary' };

export default SubmitButton;
